import { ReactNode } from 'react';
import { Autocomplete as MuiAutocomplete, createFilterOptions } from '@material-ui/lab';
import { TextField } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import equal from 'deep-equal';
import { ErrorMessage, FormLabel } from '../helpers';
import { useContextField } from '../../../api';
import { useSharedStyles } from '../../../common/sharedStyles';

export default <T extends string | { label: string; value: any; }>(props: {
    name?: string;
    options: Array<T>;
    disabled?: boolean;
    value?: string;
    autoFocus?: boolean;
    label?: string;
    onInputChange?(value: string): void;
    onChange?(selected?: T): void;
    endAdornment?: ReactNode;
    hideValidation?: boolean;
}) => {
    const { name, value, label, hideValidation, endAdornment, onChange, onInputChange, ...rest } = props;
    const [field, _, helper] = name && useContextField(name) || [];
    const sharedClasses = useSharedStyles();

    return <>
        <FormLabel label={label} />
        <MuiAutocomplete
            {...rest}
            openOnFocus
            forcePopupIcon={false}
            value={field && props.options.find((option: any) => equal(value === undefined ? field.value : value, typeof option === 'string' ? option : option.value)) || null}
            onInputChange={(_, text) => onInputChange && onInputChange(text)}
            onChange={(_, option: any) => {
                const value = option === null ? undefined : typeof option === 'string' ? option : option.value;
                onChange && onChange(value);
                helper && helper.setValue(value);
            }}
            filterOptions={filterOptions}
            getOptionLabel={option => typeof option === 'string' ? option : option.label}
            renderInput={params =>
                <TextField
                    name={name}
                    innerRef={params.InputProps.ref}
                    {...params}
                    className={sharedClasses.input}
                    variant="outlined"
                    InputProps={{
                        endAdornment: endAdornment || <Search style={{ marginRight: 30 }} />
                    }}
                />
            }
        />
        {!hideValidation && <ErrorMessage name={field?.name} />}
    </>
}

const filterOptions = createFilterOptions({ matchFrom: 'start' });
